export const typesTpOrder = {
    GET_TPORDER_SUCCESS:'GET_TPORDER_SUCCESS',
    GET_TPORDER_ERROR:'GET_TPORDER_ERROR',
    GET_TPORDER_BEGIN:'GET_TPORDER_BEGIN'
}
